<template>
    <div class="account-page-padding">
        <h1>Address Book</h1>

        <div class="address-book">
            <AddressCard
                id="new_address"       
                key="new_address" 
                v-model="newAddress" 
                :addNew="true" 
                :regions="regions" 
                @addNewAddress="addNewAddress($event)"
            />
            <AddressCard 
                v-for="(customerAddress, i) in customerAddresses"
                :id="`address_card_${i}`" 
                :key="`${customerAddress.customer_address_id}`" 
                v-model="customerAddresses[i]" 
                :regions="regions" 
                @removeAddress="openDeleteCustomerAddressModal($event)"
                @setNewDefault="setNewDefault($event)" 
            />
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { computed, ref, toRef } from "vue";
    import Account from "@/Shared/Account.vue";
    import AddressCard from "@/components/AddressCard.vue";
    import DeleteCustomerAddressModal from "@/components/DeleteCustomerAddressModal.vue"
    import { useDialog } from "primevue/usedialog";
    import { useAddressBook } from "@/helpers/composables/addressBook";
    
    const props = defineProps({
        addresses: {
            type: Array,
            default(){
                return [];
            }
        },
        regions: {
            type: Array,
            default(){
                return []
            }
        }
    })

    const {
        deleteAddress
    } = useAddressBook();

    const customerAddresses = toRef([...(props.addresses ?? [])].sort((a, b) => {
            if (b.is_default !== a.is_default) {
            return b.is_default - a.is_default;
            }
            return b.customer_address_id - a.customer_address_id;
        }));

    const newAddress = ref({
        shipping_first_name: null,
        shipping_last_name: null,
        shipping_street1: null,
        shipping_street2: null,
        shipping_street3: null,
        shipping_city: null,
        shipping_state: null,
        shipping_postal_code: null,
        shipping_country_code: "USA",
        shipping_phone: null,
        is_default: 0
    })

    const addNewAddress = (address)=>{
        customerAddresses.value.push(address);
    }

    const dialog = useDialog();

    const openDeleteCustomerAddressModal = (id) => {
        dialog.open(DeleteCustomerAddressModal, {
            props: {
                modal: true,
                showHeader: false
            },
            data: {
                customer_address_id: id,
                deleteCustomerAddress: (id)=>{
                    deleteAddress(id, {
                        afterFetch: (ctx)=>{
                            customerAddresses.value = customerAddresses.value?.filter((addr)=>(addr?.customer_address_id != id)).sort((a, b) => {
                                if (b.is_default !== a.is_default) {
                                return b.is_default - a.is_default;
                                }
                                return b.customer_address_id - a.customer_address_id;
                            });
                        }
                    })
                }
            }
        });
    };

    const setNewDefault = (id)=>{
        customerAddresses.value.forEach((address,i)=>{
            address.is_default = address.customer_address_id == id ? 1 : 0
        })

        customerAddresses.value = customerAddresses.value.sort((a, b) => {
            if (b.is_default !== a.is_default) {
            return b.is_default - a.is_default;
            }
            return b.customer_address_id - a.customer_address_id;
        });
    }

</script>